import { useMemo, FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  ModalFooter,
  Modal,
} from '@chakra-ui/react';
import { useEditBaseStore } from '../../../hooks';

type Props = ReturnType<typeof useEditBaseStore>;

export const CrawlerBaseConfirmModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onEditCrawler,
  selectedApiKeyTemplate,
}) => {
  const apiKeyTemplateValue = useMemo(
    () =>
      values.apiKeyTemplateId === '' ? '不要' : selectedApiKeyTemplate?.name,
    [selectedApiKeyTemplate?.name, values.apiKeyTemplateId],
  );

  return (
    <Modal
      isOpen={isOpenModal}
      onClose={onCloseModal}
      size="2xl"
      blockScrollOnMount
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p="40px">クローラー基本情報の更新</ModalHeader>
        <ModalCloseButton />
        <ModalBody px="40px">
          <Stack spacing="6" direction="column">
            <FormControl>
              <FormLabel>クローラーID</FormLabel>
              <Input
                type="text"
                value={values.id}
                width="240px"
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
            <FormControl>
              <FormLabel>クローラー名</FormLabel>
              <Input
                type="text"
                value={values.name}
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
            <FormControl>
              <FormLabel>イメージ名</FormLabel>
              <Input
                type="text"
                value={values.imageName}
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
            <FormControl>
              <FormLabel>APIキーテンプレート</FormLabel>
              <Input
                type="text"
                value={apiKeyTemplateValue}
                variant="flushed"
                isReadOnly
                isTruncated
              />
            </FormControl>
          </Stack>
          <Text mt="60px" align="center" fontWeight="bold">
            上記の内容でクローラー基本情報を更新しますか？
          </Text>
        </ModalBody>
        <ModalFooter gap="16px" justifyContent="center" p="40px">
          <Button
            w="140px"
            colorScheme="blackAlpha"
            variant="outline"
            onClick={onCloseModal}
          >
            キャンセル
          </Button>
          <Button colorScheme="blackAlpha" onClick={onEditCrawler} w="140px">
            更新
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
